import { observer } from "mobx-react-lite";
import {
  MdsItemListSkeletonRowData,
  MdsItemListAsyncCollectionRowData,
  MdsItemListRowType,
} from "@/design-system/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { MdsItemListSkeletonRow } from "@/design-system/components/item-list/rows/MdsItemListSkeletonRow";
import { MdsItemListItemRow } from "@/design-system/components/item-list/rows/MdsItemListItemRow";

export interface MdsItemListAsyncCollectionRowProps {
  data: MdsItemListAsyncCollectionRowData;
  className?: string;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListAsyncCollectionRow: FC<MdsItemListAsyncCollectionRowProps> = observer(
  ({ data }) => {
    const { store } = useAppStore();
    const collection = store.collections.get(data.payload.collectionId);

    const skeletonRowData: MdsItemListSkeletonRowData = {
      key: data.key,
      type: MdsItemListRowType.Skeleton,
      size: data.size,
      payload: {},
    };
    if (!collection) return <MdsItemListSkeletonRow data={skeletonRowData} />;

    const itemRowData =
      typeof data.payload.itemRow === "function"
        ? data.payload.itemRow(collection)
        : data.payload.itemRow;
    return <MdsItemListItemRow data={itemRowData} />;
  }
);
